import { useCallback } from 'react';

import useMonolithApiMutation, { UseMonolithApiMutationOptions } from '@/hooks/api/useMonolithApiMutation';
import { StartBuildErrorResponse, StartBuildResponse } from '@/hooks/useStartBuild';
import { rebuildBuildPath } from '@/utils/monolithApiRouteService';

type RebuildRequest = {
  isRemote: boolean;
};

type RebuildProps = {
  buildSlug: string;
};

const useRebuildWorkflow = (
  params: RebuildProps,
  options?: UseMonolithApiMutationOptions<StartBuildResponse, StartBuildErrorResponse, RebuildRequest>,
) => {
  const { buildSlug } = params;

  const { mutate, mutateAsync, ...rest } = useMonolithApiMutation<
    StartBuildResponse,
    StartBuildErrorResponse,
    RebuildRequest
  >(rebuildBuildPath(buildSlug), 'post', options);

  const newMutate = useCallback(
    (variables: { isRemote: boolean }) => mutate({ isRemote: variables.isRemote }),
    [mutate],
  );

  const newMutateAsync = useCallback(
    (variables: { isRemote: boolean }) => mutateAsync({ isRemote: variables.isRemote }),
    [mutateAsync],
  );

  return {
    ...rest,
    mutate: newMutate,
    mutateAsync: newMutateAsync,
  };
};

export default useRebuildWorkflow;
